import logoImg from '../assets/images/logo/logo.png';
import Comp_Popup_Contact from '../component_version2/comp_popup_contact';
import './footer.css';
export const Footer=()=>{

    return(
        <div>
            {/* <Comp_Popup_Contact/> */}
        <div className="footer-area">
        <div className="footer-container">
            <div className="footer-top">
                <div className="container">
                    <div className="row">
                        
                        <div className="col-md-6 col-lg-4 mb-md-30px mb-lm-30px">
                            <div className="single-wedge">
                            <img style={{"background":"#fff"}} src={logoImg} class="company-logo"/>
                            <p>Sheetal Copper LLC</p>
                            </div>
                        </div>
                       
                        <div className="col-md-6 col-sm-6 pl-10 col-lg-3 mb-md-30px mb-lm-30px">
                            <div className="single-wedge">
                                <h4 className="footer-herading">Information</h4>
                                <div className="footer-links">
                                    <div className="footer-row">
                                        <ul className="align-items-center">
                                            <li className="li"><a className="single-link" target='blank' href="../about_us">About Us</a></li>
                                            <li className="li"><a className="single-link" href="../products">Products</a></li>
                                            <li className="li"><a className="single-link" href="../csr">CSR</a></li>
                                            {/* <li className="li"><a className="single-link" href="../legal_assistance">Contact Us</a></li>
                                            <li className="li"><a className="single-link" href="../startup_assistance">StartUp Assitance</a></li>
                                            <li className="li"><a className="single-link" href="../blogs">Blogs</a></li> */}
                                            
                                            <li className="li"><a className="single-link" href="../Blogs">blogs</a></li>
                                            <li className="li"><a className="single-link" href="../contact_us">Contact Us</a></li>
                                            
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                        
                        <div className="col-md-6 col-lg-3 col-sm-6 mb-lm-30px">
                            <div className="single-wedge">
                                <h4 className="footer-herading">Quick Links</h4>
                                <div className="footer-links">
                                    <div className="footer-row">
                                        <ul className="align-items-center">
                                            <li className="li"><a className="single-link" href="../scrap">Scrap</a>
                                            </li>
                                            <li className="li"><a className="single-link" href="../extraction">Extraction</a></li>
                                            <li className="li"><a className="single-link" href="../Methods">Methods</a></li>
                                            {/* <li className="li"><a className="single-link" href="../specialties">Our Specialities</a></li> */}
                                            <li className="li"><a className="single-link" href="../privacy_policy">Privacy Policy</a></li>
                                            <li className="li"><a className="single-link" href="../information">Information</a></li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                        
                       
                        <div className="col-md-6 col-lg-2">
                            <div className="single-wedge">
                                <h4 className="footer-herading">newsletter</h4>
                                <div className="footer-links">
                                    
                                    <div id="mc_embed_signup" className="subscribe-form">
                                        <form id="mc-embedded-subscribe-form" className="validate" novalidate="" target="_blank" name="mc-embedded-subscribe-form">
                                            <div id="mc_embed_signup_scroll" className="mc-form">
                                                <input className="email" type="email" required="" placeholder="Your Mail*" name="EMAIL" value="" />
                                                <div className="mc-news" aria-hidden="true">
                                                    <input type="text" value="" tabindex="-1" name="b_6bbb9b6f5827bd842d9640c82_05d85f18ef" />
                                                </div>
                                                <div className="clear">
                                                    <button id="mc-embedded-subscribe" className="button btn-primary" type="submit" name="subscribe" value=""><i
                                                            className="icon-cursor"></i> Send Mail</button>
                                                </div>
                                            </div>
                                        </form>
                                    </div>
                                    
                                </div>
                            </div>
                        </div>
                        
                    </div>
                </div>
            </div>
            <div className="footer-bottom">
                <div className="container">
                    <div className="row flex-sm-row-reverse">
                        {/* <div className="col-md-6 text-right">
                            <div className="payment-link">
                                <img src="assets/images/icons/payment.png" alt="" />
                            </div>
                        </div> */}
                        <div className="col-md-12 text-left">
                            <p className="copy-text">© Copyright 2026 <strong>Sheetal Copper LLC</strong> <a className="company-name" href="javascript:void(0)">
                                {/* <strong>ashtechnologies.in</strong> */}
                                </a>.</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        </div>
        {/* <Cart_Canvas/> */}
        <div className="offcanvas-overlay"></div>
        </div>)
}
export default Footer;